import React from "react";
import { Card } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { sendingwines_support, vinologix_support } from "../config";
import AnimateWrapper from "../util/AnimateWrapper";

const NoProforma = () => {
    const { state } = useLocation();
    const contact = !state.countryFrom
        ? vinologix_support
        : state.countryFrom === "NL"
            ? vinologix_support
            : sendingwines_support;

    return (
        <AnimateWrapper>
            <h1>Geen proforma nodig</h1>
            <Card>
                <Card.Body className="w-100 h-100 d-flex justify-content-center align-items-center">
                    <p className="my-0">
                        Dit land ligt binnen de EU, u kunt dit het beste versturen met DPD in plaats van DHL express.
                        Er zijn geen extra documenten nodig. Heeft u vragen? Neem dan contact op
                        met <a href={`mailto:${contact}`}>{contact}</a>.
                    </p>
                </Card.Body>
            </Card>
        </AnimateWrapper>
    );
};

export default NoProforma;
